function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("defs", null, React.createElement("style", null, ".icon_expired_a{fill:#7b061b;}.icon_expired_b,.icon_expired_d{fill:#fff;}.icon_expired_b{opacity:0.2;}.icon_expired_c{fill:#e9eff4;}"));

var _ref3 =
/*#__PURE__*/
React.createElement("path", {
  className: "icon_expired_a",
  d: "M21.682,22.391c-3.677,3-15.159,3-18.762,0-3.677-3-3.3-15.814,0-19.187s15.46-3.373,18.762,0S25.359,19.393,21.682,22.391Z",
  transform: "translate(-0.301 -0.639)"
});

var _ref4 =
/*#__PURE__*/
React.createElement("path", {
  className: "icon_expired_b",
  d: "M12.573,16.506A17.585,17.585,0,0,1,2.142,20.553C-.41,16.206.116,5.638,3.118,2.565,5.819-.208,14.3-.732,19.178.992,20.378,5.938,17.9,12.234,12.573,16.506Z",
  transform: "translate(-0.498 0)"
});

var _ref5 =
/*#__PURE__*/
React.createElement("path", {
  className: "icon_expired_c",
  d: "M123.437,93.374,118.71,99.52a1.408,1.408,0,0,1-2.251,0l-4.728-6.146a1.461,1.461,0,0,1,0-1.724l4.728-6.146a1.408,1.408,0,0,1,2.251,0l4.728,6.146A1.459,1.459,0,0,1,123.437,93.374Z",
  transform: "translate(-105.584 -80.466)"
});

var _ref6 =
/*#__PURE__*/
React.createElement("path", {
  className: "icon_expired_d",
  d: "M120.736,86.781a16.823,16.823,0,0,1-5.028,6.445,15.841,15.841,0,0,1-2.026,1.349l-1.951-2.623a1.461,1.461,0,0,1,0-1.724l4.728-6.146a1.408,1.408,0,0,1,2.251,0Z",
  transform: "translate(-105.584 -79.119)"
});

var SvgExpired = function SvgExpired(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, ["svgRef"]);

  return React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef
  }, props), _ref2, _ref3, _ref4, _ref5, _ref6);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgExpired, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/expired.445be46f.svg";
export { ForwardRef as ReactComponent };